import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EligibleComponent } from './eligible.component';
import { EligibleViewComponent } from './eligible-view/eligible-view.component';
import { EligibleFilterViewComponent } from './eligible-view/eligible-filter-view/eligible-filter-view.component';
import { EligibleFormComponent } from './eligible-form/eligible-form.component';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '@app-shared/pipes/shared-pipes.module';
import { SharedDirectivesModule } from '@app-shared/directives/shared-directives.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { CheckBoxModule } from '../checkbox/checkbox.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
	declarations: [EligibleComponent, EligibleViewComponent, EligibleFilterViewComponent, EligibleFormComponent],
	imports: [
		CommonModule,
		RouterModule,
		SharedPipesModule,
		SharedDirectivesModule,
		NgbModule,
		FileUploadModule,
		MatProgressSpinnerModule,
		FormsModule,
		MatDialogModule,
		MatInputModule,
		MatTooltipModule,
		MatSelectModule,
		ReactiveFormsModule,
		CheckBoxModule,
		MatCheckboxModule,
		MatIconModule
	],
	exports: [EligibleComponent, EligibleViewComponent, EligibleFilterViewComponent, EligibleFormComponent]
})
export class EligibleModule {}
